import { I18nComponente } from "@/types/gerais"

export const ODetalhesEventoPlanejadoi18n: I18nComponente = {
  "pt-BR": {
    inicio: "início",
    fim: "fim",
    editar: "editar",
    deletar: "deletar",
    voltar: "voltar",
    simDeletar: "sim, deletar",
    deletarAtividadePlanejada: "deletar atividade planejada?",
    deletarSomenteEstaAtividade: "deletar somente esta atividade",
    deletarEstaAtividadeAsSeguintes: "deletar esta atividade e as seguintes",
    deletarTodasAsAtividades: "deletar todas as atividades",
    aoDeletar: "ao deletar, as atividades planejadas serão removidas do sistema permanentemente e não será possível recuperá-las de acordo com a opção selecionada.",
    atividadePlanejadaFoiDeletada: "A atividade planejada foi deletada",
    calendarioEstaSendoAtualizado: "o calendário está sendo atualizado",
    naoFoiPossivelDeletarAtividadePlanejada: "Não foi possível deletar a atividade planejada!",
    asAtividadesForamDeletadas: "As atividades foram deletadas",
    naoFoiPossivelDeletarAsAtividades: "Não foi possível deletar as atividades!",
    naoFoiPossivelDeletarTodasAsAtividades: "Não foi possível deletar todas as atividades!",
    ocorreuUmErro: "Ocorreu um erro",
    naoPossivelBuscarOsDadosDoCalendarioDoEvento: "Não foi possível buscar os dados do calendário do evento",
    naoFoiPossívelAcessarOsEventosDoCalendario: "Não foi possível acessar os dados do calendário",
    etapaAtividade: "Atividade",
    etapaAtributos: "Atributos"
  },
  "es-CO": {
    inicio: "inicio",
    fim: "fin",
    editar: "editar",
    deletar: "borrar",
    voltar: "volver",
    simDeletar: "sí, borrar",
    deletarAtividadePlanejada: "borrar actividad planeada?",
    deletarSomenteEstaAtividade: "borrar solo esta actividad",
    deletarEstaAtividadeAsSeguintes: "borrar esta actividad y las siguientes",
    deletarTodasAsAtividades: "borrar todas las actividades",
    aoDeletar: "al borrar, la actividad planeada se eliminará del sistema permanentemente y no se podrá recuperar.",
    aAtividadePlanejadaFoiDeletada: "La actividad planeada fue borrada",
    calendarioEstaSendoAtualizado: "el calendario se está actualizando",
    naoFoiPossivelDeletarAtividadePlanejada: "No fue posible borrar la actividad planeada!",
    asAtividadesForamDeletadas: "Las actividades fueron borradas",
    naoFoiPossivelDeletarAsAtividades: "No fue posible borrar las actividades!",
    naoFoiPossivelDeletarTodasAsAtividades: "No fue posible borrar todas las actividades!",
    ocorreuUmErro: "Ocurrió un error",
    naoPossivelBuscarOsDadosDoCalendarioDoEvento: "No fue posible buscar los datos del calendario del evento",
    naoFoiPossívelAcessarOsEventosDoCalendario: "No fue posible acceder a los datos del calendario",
    etapaAtividade: "Actividad",
    etapaAtributos: "Atributos"
  }
}
